<template>
  <div class="vb-detail vb-detail--only-stay">

    <div v-if="!hotel_data || !hotel_data.data">
      <b-alert show variant="warning">
        Nessun dato disponibile per questa struttura.
      </b-alert>
    </div>

    <div v-else>
      <!-- Header hotel -->
      <div class="d-flex align-items-center justify-content-between mb-2">
        <router-link :to="{name: 'results'}">
          <span class="vb-detail__back">indietro</span>
        </router-link>
      </div>

      <div class="mt-3 d-flex align-items-start">
        <h1 class="mr-2">{{ hotel.name }}</h1>
        <div class="vb-detail__head-star" v-if="hotel.rating && hotel.rating.stars">
          <b-form-rating
            no-border inline readonly
            variant="secondary"
            :value="hotel.rating.stars"
          />
        </div>
      </div>

      <div class="vb-detail__head mb-4">
        <div class="vb-detail__head-city" v-if="hotel.location">
          <vb-icon
            class="mr-1"
            :name="'pin'"
            :size="14"
            :color="sass('gray-500')"
          /><span class="text-capitalize">{{ location_label }}</span>
        </div>
        <div class="vb-detail__head-brand">
          <img :src="'assets/images/alpitour/liveat-brands/'+get_brand(hotel.brand).logo" :alt="get_brand(hotel.brand).name" />
        </div>
      </div>

      <div v-for="(block, key) in detail_blocks" :key="_uid+key">
        <component
          :key="_uid+block+key"
          :is="block"
          :hotel_data="hotel_data"
        />
      </div>

      <!--    RECAP PACCHETTO -->
      <card-recap-only-stay
        v-if="room_selection.index !== null"
        class="section mt-4"
        :hotel_data="hotel_data"
      />

      <!-- CTA continua -->
      <room-select-button
        ref="room_select_button"
        :disabled="room_selection.index === null"
      />
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import {get_brand} from '@alpitour/resources'
import { alpitour_rybbit_event, slim_room_info } from "@alpitour/utilities/rybbit"
import Carousel from '@alpitour/components/blocks/detail/carousel.vue'
import Description from '@alpitour/components/blocks/detail/description.vue'
import ServicesAll from '@alpitour/components/blocks/detail/services-all.vue'
import Rooms from '@alpitour/components/blocks/detail/rooms.vue'
import CardRecapOnlyStay from '@alpitour/components/blocks/card-recap-only-stay.vue'
import RoomSelectButton from '@alpitour/components/blocks/detail/room-select-button.vue'

export default {
  name: 'detail-only-stay',

  provide() {
    return {
      on_room_selected: this.on_room_selected,
      room_selection: this.room_selection,
    }
  },

  components: {
    'carousel': Carousel,
    'description': Description,
    'services-all': ServicesAll,
    'rooms': Rooms,
    'card-recap-only-stay': CardRecapOnlyStay,
    'room-select-button': RoomSelectButton,
  },

  props: {
    hotel_data: {
      type: Object,
      default: () => ({}),
    },
  },

  created() {
    this.get_brand = get_brand
  },

  data() {
    return {
      detail_blocks: [],
      room_selection: { index: null, rate: null },
    }
  },

  mounted() {
    this.detail_blocks = [
      'carousel',
      'description',
      'rooms',
      'services-all',
    ]
  },

  updated() {
    if (this.room_selection.index !== null) {
      this.scroll_into_view()
    }
  },

  computed: {
    ...mapState('liveat', ['detail_params', 'solution_id']),

    hotel() {
      return (this.hotel_data && this.hotel_data.data) || {}
    },

    location_label() {
      const loc = this.hotel.location || {}
      return [loc.city, loc.country].filter(Boolean).join(', ').toLowerCase()
    },
  },

  methods: {
    on_room_selected(payload) {
      this.room_selection.index = payload.room_index
      this.room_selection.rate = payload.rate

      const rate = payload.rate || {}
      const { solution: rate_solution = {}, pricing = {} } = rate
      const { checkin = '', checkout = '' } = this.detail_params || {}
      const nights = checkin && checkout
        ? Math.round((new Date(checkout) - new Date(checkin)) / 86400000)
        : 0

      const selected_room = {
        room_index: payload.room_index,
        rate,

        quote_payload: {
          solution: {
            id: rate_solution.id || this.solution_id,
            room_ref: rate_solution.room_ref,
          },
          locale: 'IT',
          totAmount: pricing.total || 0,
        },

        solution: {
          idSolution: rate_solution.id || this.solution_id,
          roomRef: rate_solution.room_ref,
          dateFrom: checkin,
          dateTo: checkout,
          nights,
        },
      }

      this.$store.commit('liveat/update_selected_room', selected_room)
      alpitour_rybbit_event("package:room:select", slim_room_info(selected_room))
    },
    scroll_into_view() {
      if (this.$refs.room_select_button) {
        this.$refs.room_select_button.scroll_into_view()
      }
    },
  },
}
</script>
